import { makeStyles } from '@mui/styles'
import PageTemplateData from '@v4/utils/data/PageTemplateData'

const useStyles = makeStyles(
	theme => ({
		root: {
			position: ({ metaData }) => metaData.position?.metaValue || 'relative',
			left: 0,
			right: 0,
			cursor: ({ isBuilderMode }) => (isBuilderMode ? 'pointer' : 'default'),
			backgroundColor: ({ metaData }) =>
				metaData.backgroundDefault?.metaValue === 'transparent' ? 'transparent' : null,
			transition: theme.transitions.create(['background-color', 'padding-top', 'padding-bottom']),
			[`&$${PageTemplateData.SECTION_TYPES.BANNER}`]: {
				overflow: 'hidden',
			},
			[`&:not($${PageTemplateData.SECTION_TYPES.HEADER}):not($${PageTemplateData.SECTION_TYPES.FOOTER})` +
			`:not($${PageTemplateData.SECTION_TYPES.POPUP})` +
			`:not($${PageTemplateData.SECTION_TYPES.QUESTION_PROGRESS}):not($pdf)`]: {
				display: 'flex',
				flexGrow: 1,
				flexDirection: 'column',
				'& $container': {
					flexGrow: 1,
					display: 'flex',
				},
				'& $content': {
					height: '100%',
					flexGrow: 1,
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
				},
			},
		},
		[PageTemplateData.SECTION_TYPES.BANNER]: {},
		[PageTemplateData.SECTION_TYPES.POPUP]: {},
		[PageTemplateData.SECTION_TYPES.QUESTION_PROGRESS]: {},
		[PageTemplateData.SECTION_TYPES.HEADER]: {
			zIndex: 11,
		},
		[PageTemplateData.SECTION_TYPES.FOOTER]: {
			marginTop: 'auto',
			zIndex: 11,
			bottom: ({ metaData }) => {
				switch (metaData.position?.metaValue) {
					case 'absolute':
					case 'fixed':
						return 0
					default:
						return undefined
				}
			},
		},
		[PageTemplateData.SECTION_TYPES.CATEGORIES_SCORES]: {
			zIndex: 3,
		},
		container: {
			width: '100%',
		},
		content: {
			width: '100%',
		},
		pdf: {
			height: theme.spacing(106.125),
			'&:not(:last-child)': {
				'page-break-after': 'always',
			},
			overflow: 'hidden',
			'@media print': {
				boxShadow: null,
				marginBottom: 0,
				height: '100vh',
			},
			'& $container': {
				flexGrow: 1,
				height: '100%',
				display: 'flex',
			},
			'& $content': {
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
			},
			'@media screen': {
				boxShadow: () => theme.shadows[5],
				'&:nth-child(n+2)': {
					marginTop: ({ isBuilderMode }) => (!isBuilderMode ? theme.spacing(2) : null),
				},
			},
		},
		themeButton: {
			opacity: 0,
			transition: theme.transitions.create(['opacity']),
		},
		themeButtonVisible: {
			'& $themeButton': {
				opacity: 1,
			},
		},
	}),
	{ name: 'SectionItem' },
)

export default useStyles
